import React from 'react';
import { useFormContext } from 'react-hook-form';
export default function useFormInstance() {
    const methods = useFormContext();
    if (methods == null) {
        return null;
    }
    return { ...methods };
}
//# sourceMappingURL=useFormInstance.js.map